import { createSelector } from 'reselect'

const selectTableData = (state) => state.table

export const selectTableDataItems = (tableType) => createSelector(
    selectTableData,
    (tableData) => { 
        
        return tableData[tableType].items
    }
)

export const selectDataUrl = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].url
)

export const selectDatDeleteUrl = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].deleteUrl
)

export const selectDatAddUrl = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].addUrl
)

export const selectDatUpdateUrl = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].updateUrl
)

export const selectDataImportUrl = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].importUrl
)

export const selectSearchQuery = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].search
)

export const selectId = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType]?.id || null
)

export const selectFilters = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].filters
)

export const selectSort = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].sort
)

export const selectPerPage = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].page_info.page_size
)

export const selectTableCurrentPage = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].page_info.current_page
)

export const selectTableTotalRows = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].page_info.total_rows
)

export const selectTableAddLoading = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].adding.loading
)

export const selectTableAddIsDone = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].adding.isDone
)

export const selectAddErrors = (tableType) => createSelector(
    selectTableData,
    (tableData) => {
        const validations = {}
        const errorText = ""

        if (tableData[tableType].adding.errors) {
            if (tableData[tableType].adding.errors !== null 
                && typeof (tableData[tableType].adding.errors.non_field_errors) !== 'undefined'
                && typeof (tableData[tableType].adding.errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                tableData[tableType].adding.errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(tableData[tableType].adding.errors).length > 0) {
                for (const k in tableData[tableType].adding.errors) {
                    validations[k] = tableData[tableType].adding.errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)


export const selectTableUpdateLoading = (tableType, id) => createSelector(
    selectTableData,
    (tableData) => (tableData[tableType].updating[id]?.loading ? tableData[tableType].updating[id]?.loading : false)
)

export const selectTableUpdateIsDone = (tableType, id) => createSelector(
    selectTableData,
    (tableData) => (tableData[tableType].updating[id]?.isDone ? tableData[tableType].updating[id]?.isDone : false)
)

export const selectUpdateErrors = (tableType, id) => createSelector(
    selectTableData,
    (tableData) => {
        const validations = {}
        const errorText = ""

        if (tableData[tableType].updating[id]?.errors) {
            if (tableData[tableType].updating[id].errors !== null 
                && typeof (tableData[tableType].updating[id].errors.non_field_errors) !== 'undefined'
                && typeof (tableData[tableType].updating[id].errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                tableData[tableType].updating[id].errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(tableData[tableType].updating[id].errors).length > 0) {
                for (const k in tableData[tableType].updating[id].errors) {
                    validations[k] = tableData[tableType].updating[id].errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)

export const selectTableImportLoading = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].import.loading
)

export const selectTableImportIsDone = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].import.isDone
)

export const selectTableImportErrors = (tableType) => createSelector(
    selectTableData,
    (tableData) => {
        const validations = {}
        const errorText = ""

        if (tableData[tableType].import.errors) {
            if (tableData[tableType].import.errors !== null 
                && typeof (tableData[tableType].import.errors.non_field_errors) !== 'undefined'
                && typeof (tableData[tableType].import.errors.non_field_errors) !== 'string'
            ) {
                let html = ''

                tableData[tableType].import.errors.non_field_errors.map((val) => {
                    html += val.message
                })

                errorText = html
            } else if (Object.keys(tableData[tableType].import.errors).length > 0) {
                for (const k in tableData[tableType].import.errors) {
                    validations[k] = tableData[tableType].import.errors[k][0]
                }
            }
        }

        return {validations, errorText}
    }
)

export const selectCellLoadingUrl = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType]?.cellLoadingUrl
)


export const selectCellData = (tableType, id) => createSelector(
    selectTableData,
    (tableData) => { 
        return typeof tableData[tableType]?.cellLoading[id]?.data !== "undefined" ? tableData[tableType]?.cellLoading[id]?.data : {}
    }
)

export const selectCellLoading = (tableType, id) => {
    return createSelector(
        selectTableData,
        (tableData) => {
            return tableData[tableType]?.cellLoading[id]?.loading ? tableData[tableType].cellLoading[id]?.loading : false
        }
    )
}

export const selectCellIsDone = (tableType, id) => createSelector(
    selectTableData,
    (tableData) => (tableData[tableType]?.cellLoading[id]?.isDone ? tableData[tableType]?.cellLoading[id]?.isDone : false)
)

export const selectRegisterUrl = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].registerUrl
)

export const selectTableRegistering = (tableType, id) => createSelector(
    selectTableData,
    (tableData) => (tableData[tableType].registering[id]?.loading ? tableData[tableType].registering[id]?.loading : false)
)

export const selectTableRegistered = (tableType, id) => createSelector(
    selectTableData,
    (tableData) => (tableData[tableType].registering[id]?.registered ? tableData[tableType].registering[id]?.isDone : false)
)

export const selectTableRegisteringMain = (tableType) => createSelector(
    selectTableData,
    (tableData) => tableData[tableType].is_registering
)